import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-contact-cta',
  standalone: true,
  imports: [RouterLink],
  template: `
  <section class="cta">
    <div class="cta__bg" aria-hidden="true"></div>

    <div class="cta__inner">
      <h2 class="h2">Prêt à booster votre data ?</h2>

      <div class="checks">
        <div class="check">✓ Audit gratuit</div>
        <div class="check">✓ Réponse sous 48h</div>
        <div class="check">✓ Conseils personnalisés</div>
      </div>

      <a class="btn primary big" routerLink="/contact">Contactez‑nous</a>
    </div>
  </section>
  `,
  styles: [`
    .cta{
      position:relative;
      border-radius: 26px;
      border: 1px solid rgba(255,255,255,.10);
      overflow:hidden;
      box-shadow: 0 30px 120px rgba(0,0,0,.55);
      min-height: 220px;
      background: rgba(255,255,255,.03);
    }

    .cta__bg{
      position:absolute; inset:-30%;
      background:
        radial-gradient(700px 420px at 20% 20%, rgba(79,125,255,.25), transparent 62%),
        radial-gradient(700px 420px at 80% 30%, rgba(0,229,168,.18), transparent 62%),
        radial-gradient(700px 420px at 60% 90%, rgba(168,85,247,.12), transparent 62%),
        linear-gradient(180deg, rgba(7,11,23,.4), rgba(7,11,23,.85));
      background-size: cover;
      background-position: center;
      filter: saturate(1.05) contrast(1.05);
      opacity: .95;
      pointer-events:none;
      animation: bg 10s ease-in-out infinite;
    }
    @keyframes bg{
      0%,100%{ transform: translate3d(0,0,0) scale(1); }
      50%{ transform: translate3d(-1.5%, 1%, 0) scale(1.03); }
    }

    .cta__inner{
      position:relative;
      padding: 18px;
      display:flex;
      flex-direction:column;
      gap: 12px;
      align-items:flex-start;
    }
    .checks{ display:flex; flex-wrap:wrap; gap: 10px; }
    .check{
      padding: 10px 12px;
      border-radius: 999px;
      border: 1px solid rgba(255,255,255,.12);
      background: rgba(255,255,255,.06);
      color: rgba(235,240,255,.82);
      font-weight: 900;
      font-size: 12px;
    }
    .big{ padding: 12px 16px; border-radius: 16px; font-weight: 1000; }

    @media (max-width: 980px){
      .cta{ min-height: 200px; }
    }
  `]
})
export class ContactCtaComponent {}
